import { Route } from 'react-router-dom';
import ReportsPage from '../../pages/raptor/reports/reports.page';

export const RaptorReportsRoutes = (
  <Route path="/reports">
    <Route index element={<ReportsPage />} />
  </Route>
);
